var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"d-inline-block rounded-xl custom-background my-1"},[_c('v-card-text',{staticClass:"pa-0"},[_c('v-breadcrumbs',{staticClass:"pa-4",attrs:{"items":_vm.items,"large":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }